export const enum paymentType {
  CREDIT_DEBIT = 'CreditDebit',
  PROMPT_PAY_QR = 'PromptPayQr',
  FREE = 'Free',
}

export const enum propmtPayStatus {
  CREATED = 'Created',
  PAID = 'Completed',
  UNPAID = 'Error',
}

export const enum trackingStatus {
  CREATED = 'Created',
  PAID = 'Paid',
  UNPAID = 'Unpaid',
}

export const trackingCheckingLiftTime = 5000;

export const enum confirmReserveType {
  CREDIT_CARD = 'CreditCard',
  PROMPT_PAY = 'PromptPay',
}

export const omiseLimitAmount = 300000;
